import ConversionResultFormatter from "./conversionResultFormatter.js";

class CompositeResultFormatter extends ConversionResultFormatter{
  constructor(...formatters) {
    if ((formatters instanceof Array) === false) {
      throw new TypeError("Please pass an array of formatters");
    }

    if (formatters.find(formatter => (formatter instanceof ConversionResultFormatter) === false)) {
      throw new TypeError("All elements should extend ConversionResultFormatter");
    }

    super();

    this.formatters = [].concat(formatters);
  }

  stringify (value, thousandSeparator, decimalSeparator) {
    let stringified = value;
    for (let index = 0; index < this.formatters.length; index++) {
      let formatter = this.formatters[index];
      stringified = formatter.stringify(stringified, thousandSeparator, decimalSeparator);
    }

    return stringified;
  }

  stringifyUnitSymbol (stringified, symbolPrefix, symbolSuffix, unit, unitSymbolIndex) {
    let formatted = stringified;
    for (let index = 0; index < this.formatters.length; index++) {
      let formatter = this.formatters[index];
      formatted = formatter.stringifyUnitSymbol(formatted, symbolPrefix, symbolSuffix, unit, unitSymbolIndex);
    }

    return formatted;
  }
}

export default CompositeResultFormatter;
